export default __webpack_public_path__ + "static/5-f49bfd08cb562fda0b847e9c996a0000.jpeg";